import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(HttpBackend) // loads translation files via HTTP (default public folder)
    .use(LanguageDetector) // detects the user's language (from browser settings, localStorage, etc.)
    .use(initReactI18next) // connects i18next to React
    .init({
        fallbackLng: 'en', // default language if the detected language is not available
        debug: false, // enable true for debugging language issues

        interpolation: {
            escapeValue: false, // not needed for React (it escapes by default)
        },

        backend: {
            loadPath: '/locales/{{lng}}/common.json' // path to translation files
        }
    });

export default i18n;